import React from 'react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function HeroSection() {
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-emerald-900 via-teal-800 to-cyan-900 text-white overflow-hidden" data-id="element-172">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/20" data-id="element-173"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-32" data-id="element-174">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-175">
          {/* Left: Copy */}
          <div className="text-center lg:text-left space-y-8" data-id="element-176">
            <div className="inline-block bg-emerald-500/20 backdrop-blur-sm px-4 py-2 rounded-full border border-emerald-400/30" data-id="element-177">
              <span className="text-emerald-300 text-sm font-semibold" data-id="element-178">
                💰 El Primer Paso Hacia Tu Libertad Financiera
              </span>
            </div>

            <h1 className="font-serif text-4xl lg:text-6xl leading-tight" data-id="element-179">
              No Todos Están Listos Para Empezar Su{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400" data-id="element-180">
                Transformación Financiera
              </span>
              … Pero Tú Sí Lo Estás
            </h1>

            <h2 className="font-serif text-3xl lg:text-4xl text-emerald-300" data-id="element-181">
              Sobrevive a la Quincena
            </h2>

            <p className="text-xl lg:text-2xl text-gray-200 leading-relaxed" data-id="element-182">
              El primer paso hacia una vida con estabilidad, claridad y libertad
              financiera
            </p>

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-183">
              No te promete hacerte rica de la noche a la mañana. Te enseña algo
              mucho más importante:{' '}
              <strong className="text-emerald-400" data-id="element-184">
                Cómo dejar de sabotear tu futuro financiero sin darte cuenta.
              </strong>
            </p>

            <div className="flex flex-col sm:flex-row gap-4 text-lg text-gray-200" data-id="element-185">
              <div className="flex items-center gap-2" data-id="element-186">
                <span className="text-emerald-400 text-2xl" data-id="element-187">✔</span>
                <span data-id="element-188">50 hacks reales</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-189">
                <span className="text-emerald-400 text-2xl" data-id="element-190">✔</span>
                <span data-id="element-191">Paso a paso</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-192">
                <span className="text-emerald-400 text-2xl" data-id="element-193">✔</span>
                <span data-id="element-194">Para tu realidad</span>
              </div>
            </div>

            <div className="space-y-4 pt-4" data-id="element-195">
              <Button size="lg" className="w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600" href={CHECKOUT_URL} data-id="element-196">
                👉 Sí, quiero empezar mi camino hacia la libertad financiera
              </Button>

              <p className="text-sm text-gray-300" data-id="element-197">
                Empieza hoy. Aprende a manejar tu quincena. Construye la base de
                tu futuro financiero.
              </p>
            </div>

            {/* Social Proof */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-198">
              <div className="flex items-center justify-center lg:justify-start gap-2 mb-3" data-id="element-199">
                <span className="text-yellow-400 text-xl" data-id="element-200">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="text-sm text-gray-300 mb-4" data-id="element-201">
                Más de 1,000 personas ya están tomando control de sus finanzas
              </p>
              <div className="border-l-4 border-emerald-400 pl-4" data-id="element-202">
                <p className="text-white italic mb-2" data-id="element-203">
                  "Por primera vez en años, llegué al final de la quincena con
                  dinero en la cuenta."
                </p>
                <p className="text-sm text-gray-400" data-id="element-204">— Carmen, 32</p>
              </div>
            </div>
          </div>

          {/* Right: Hero Image */}
          <div className="relative" data-id="element-205">
            <div className="relative z-10 transform hover:scale-105 transition-transform duration-500" data-id="element-206">
              <img src="https://cdn.magicpatterns.com/uploads/q3FcGqGMwQVZL9GK8NVq6q/ChatGPT_Image_19_dic_2025,_12_22_05.png" alt="Sobrevive a la Quincena - El primer paso hacia tu libertad financiera" className="w-full rounded-3xl shadow-2xl" data-id="element-207" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-400 rounded-full blur-3xl opacity-30" data-id="element-208"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-cyan-500 rounded-full blur-3xl opacity-30" data-id="element-209"></div>
          </div>
        </div>
      </div>
    </section>;
}